import { BaseCriteriaModel } from './base-criteria.model';
import { Optional } from 'typescript-optional';

export class PricingSchemeHdrQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
  param_code?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class PricingSchemeHdrCriteriaModelQuery {
  query = '';

  constructor(PricingSchemeCriteriaModel: PricingSchemeHdrQueryCriteriaClass) {
    if (!PricingSchemeCriteriaModel) {
      return;
    }
    this.query += PricingSchemeCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += PricingSchemeCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += PricingSchemeCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += PricingSchemeCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += PricingSchemeCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += PricingSchemeCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    //this.query += '&status=' + PricingSchemeCriteriaModel.status;
    //this.query += '&orderBy=' + PricingSchemeCriteriaModel.orderBy;
    //this.query += '&order=' + PricingSchemeCriteriaModel.order;
    //this.query += '&offset=' + PricingSchemeCriteriaModel.offset + '&limit=' + PricingSchemeCriteriaModel.limit;
  }
}